import { Button, Text } from '@flatfile/baseline'
import { useIdentity } from '../../hooks/useIdentity'

export function ProjectsRequestPage() {
  const { identity } = useIdentity()
  const projectsImage = '/images/projects.svg'
  const email = identity.user.email
  const fullname = identity.user.name.split(' ')
  const firstname = fullname[0]
  const lastname = fullname.length > 1 ? fullname[1] : 'n/a'
  const company = identity.account.name

  const href = `https://flatfile.com/contact-sales/consult?email=${email}&firstname=${firstname}&lastname=${lastname}&company=${company}`

  return (
    <div className='text-center p-8'>
      <h3 className='text-xl font-semibold mb-2 mt-8'>Collaborate on data onboarding projects</h3>
      <Text className='text-sm'>
        Use Flatfile Projects to streamline complex data workflows across diverse stakeholders.
      </Text>
      <div className='h-8' />
      <div className='mt-8 text-left grid grid-cols-1 lg:grid-cols-12 items-center'>
        <div className='lg:col-span-3 lg:col-start-2'>
          <ul className='space-y-8 text-sm'>
            <li className='flex gap-3'>
              <div
                className='bg-gray-100 rounded-full p-1.5 flex items-center justify-center'
                style={{ width: '24px', height: '24px' }}
              >
                <span className='text-xs'>✓</span>
              </div>
              <span>
                Onboard new customers or solve any collaborative need for importing, validating, editing and approving
                data
              </span>
            </li>
            <li className='flex gap-3'>
              <div
                className='bg-gray-100 rounded-full p-1.5 flex items-center justify-center'
                style={{ width: '24px', height: '24px' }}
              >
                <span className='text-xs'>✓</span>
              </div>
              <span>
                Let external and internal teams easily work together on shared data files - no more sending Excel files
                back-and-forth via email
              </span>
            </li>
            <li className='flex gap-3'>
              <div
                className='bg-gray-100 rounded-full p-1.5 flex items-center justify-center'
                style={{ width: '24px', height: '24px' }}
              >
                <span className='text-xs'>✓</span>
              </div>
              <span>
                Code-based validations, transformations, and workflows ensure data is squeaky clean, approved, and
                production ready
              </span>
            </li>
          </ul>
        </div>
        <div className='lg:col-span-6 lg:col-start-7 mt-8 lg:mt-0'>
          <div className='p-8 flex flex-col justify-between border'>
            <div>
              <img src={projectsImage} alt='Projects Image' className='w-full' />
            </div>
            <div className='pt-4 pb-2'>
              <h4 className='text-lg font-semibold mb-2'>Interested?</h4>

              <Text className='text-sm'>
                Talk to one of our product experts to learn how Flatfile Projects transforms data onboarding as you know
                it.
              </Text>
            </div>
            <div className='pb-2 pt-4'>
              <div className='flex gap-4'>
                <a href={href} target='_blank' rel='noopener noreferrer' className='flex items-center gap-1'>
                  <Button size='sm'>
                    Connect with a product expert <span className='ml-1'>→</span>
                  </Button>
                </a>
                <a
                  href='https://flatfile.com/platform/projects/'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='flex items-center gap-1'
                >
                  <Button variant='outline' size='sm'>
                    Learn more <span className='ml-1'>→</span>
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='lg:col-span-1'></div>
      </div>
    </div>
  )
}
